import { useEffect, useState } from "react";
import Loading from "../loading/Loading";
import { Link } from "react-router-dom";
import { Alert, Card, Col, Container, Nav, Row, Table } from "react-bootstrap";
import { getCoordinadoresDeEquipoRoles } from "../../controllers/org";

function ComunidadEquiposLista({ equipos = [], miembros = [] }) {
  const [coordinadoresDeEquipoRoles, setCoordinadoresDeEquipoRoles] = useState();

  useEffect(() => {
    loadCoordinadoresDeEquipoRoles();
  }, []);

  async function loadCoordinadoresDeEquipoRoles() {
    let r = await getCoordinadoresDeEquipoRoles();
    setCoordinadoresDeEquipoRoles(r);
  }

  function renderEquipos() {
    console.log('coordinadoresDeEquipoRoles', coordinadoresDeEquipoRoles);
    if (!coordinadoresDeEquipoRoles) {
      return '';
    }
    else if (!equipos.length) {
      return <Alert variant="warning">No hay equipos en esta comunidad.</Alert>
    }

    return equipos.map((equipo, i) => {
      let miembrosEquipo = miembros.filter(m => {
        return equipo.team_members.find(tm => tm.membership_id === m.membership_id);
      });
      const coordinador = miembrosEquipo.find(m => {
        if (m.membership_roles.find(mr => mr.role_id === coordinadoresDeEquipoRoles[equipo.etapa.type])) {
          return m;
        }
      });

      return <Col xl={3} lg={6} key={`equipo-${equipo.team_id}`} className="mb-3">
        <Card key={`equipo-${equipo.team_id}`}>
          <Card.Header>{coordinador.label}</Card.Header>
          <Card.Body>
            <p>Miembros: {equipo.team_members.length}</p>
            
            {!equipo.reporte_temas.length ? <p>No se han capturado reportes de temas.</p> : ''}
            {equipo.reporte_temas.length ? <p>Último tema visto: Tema {equipo.reporte_temas[equipo.reporte_temas.length -1].tema.tema_num}</p> : ''}
            <p><Link to={`/app/org/teams/${equipo.team_id}`}>Ver más</Link> </p>
          </Card.Body>
        </Card>
      </Col>;
    });
  }

  function renderEquipos2() {
    console.log('coordinadoresDeEquipoRoles', coordinadoresDeEquipoRoles);
    if (!coordinadoresDeEquipoRoles) {
      return '';
    }
    else if (!equipos.length) {
      return <Alert variant="warning">No hay equipos en esta comunidad.</Alert>
    }

    return equipos.map((equipo, i) => {
      let miembrosEquipo = miembros.filter(m => {
        return equipo.team_members.find(tm => tm.membership_id === m.membership_id);
      });
      const coordinador = miembrosEquipo.find(m => {
        if (m.membership_roles.find(mr => mr.role_id === coordinadoresDeEquipoRoles[equipo.etapa.type])) {
          return m;
        }
      });

      return <tr key={`equipo-row-${equipo.team_id}`}>
        <td>{coordinador.label}</td>
      </tr>
    });
  }

  return <Container>
    <Row>{renderEquipos()}</Row>
  </Container>;
}

export default ComunidadEquiposLista;